function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiIconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
const IconButton = ({
  icon,
  id = "IconButton-default-id",
  label = "",
  tooltipPlacememnt = "bottom",
  classes,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: t(label),
    arrow: true,
    placement: tooltipPlacememnt,
    classes: classes
  }, /*#__PURE__*/React.createElement(MuiIconButton, _extends({
    id: id,
    "aria-label": label
  }, rest), icon));
};
IconButton.propTypes = {
  id: PropTypes.string,
  tooltipPlacememnt: PropTypes.string,
  classes: PropTypes.object,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired
};
export default IconButton;